import React, { useRef, useState, useEffect } from 'react';
import emailjs from '@emailjs/browser';

declare global { interface Window { grecaptcha: any; } }

export function ContactPage() {
  const formRef = useRef<HTMLFormElement>(null);
  const recaptchaRef = useRef<HTMLDivElement>(null);
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      if (window.grecaptcha && window.grecaptcha.render && recaptchaRef.current && !recaptchaRef.current.hasChildNodes()) {
        window.grecaptcha.render(recaptchaRef.current, { sitekey: '6LfFM_YsAAAAALUW4QGVeMk2xrPf4sAJPXlcIhe9' });
        clearInterval(interval);
      }
    }, 100);
    return () => clearInterval(interval);
  }, []);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!formRef.current) return;
    const response = window.grecaptcha?.getResponse();
    if (!response) { alert('Please complete the reCAPTCHA.'); return; }
    setSending(true);
    emailjs.sendForm('service_ecjoxln', 'template_i8bv94m', formRef.current, 'WGhWRxHAfs-zdamaD')
      .then(() => { setSent(true); setSending(false); formRef.current?.reset(); window.grecaptcha.reset(); })
      .catch(() => { setSending(false); alert('Failed to send. Please try again.'); });
  };

  return (
    <div className="page-content">
      <section className="hero is-medium has-background-dark">
        <div className="hero-body">
          <div className="container has-text-centered">
            <h1 className="title is-1 has-text-white">Contact Us</h1>
            <p className="subtitle has-text-grey-light">Ready to add esports pricing to your sportsbook? Let's talk.</p>
          </div>
        </div>
      </section>

      <section className="section contact-section">
        <div className="container">
          <div className="columns is-centered">
            <div className="column is-6">
              <div className="content has-text-centered mb-6">
                <p className="has-text-grey-light is-size-5">
                  Whether you're an operator looking to launch esports markets or want to improve your existing pricing, we'd love to hear from you.
                </p>
              </div>
            </div>
          </div>

          <div className={"contact-form-wrapper" + (sending || sent ? " is-sent" : "")}>
            <div className="columns is-centered">
              <div className="column is-8">
                <form ref={formRef} onSubmit={handleSubmit} className="columns is-multiline">
                  <div className="column is-6">
                    <div className="field"><label className="label has-text-white">Name</label><div className="control"><input className="input contact-input" type="text" name="name" placeholder="Your name" required /></div></div>
                  </div>
                  <div className="column is-6">
                    <div className="field"><label className="label has-text-white">Company</label><div className="control"><input className="input contact-input" type="text" name="company" placeholder="Your company" required /></div></div>
                  </div>
                  <div className="column is-6">
                    <div className="field"><label className="label has-text-white">Email</label><div className="control"><input className="input contact-input" type="email" name="email" placeholder="your@email.com" required /></div></div>
                  </div>
                  <div className="column is-6">
                    <div className="field"><label className="label has-text-white">Role</label><div className="control"><div className="select is-fullwidth contact-select"><select name="role"><option>Sportsbook Operator</option><option>Trading Desk</option><option>Platform Provider</option><option>Other</option></select></div></div></div>
                  </div>
                  <div className="column is-12">
                    <div className="field"><label className="label has-text-white">Message</label><div className="control"><textarea className="textarea contact-input" name="message" placeholder="Tell us about your esports pricing needs..." required></textarea></div></div>
                  </div>
                  <div className="column is-12 has-text-centered">
                    <div ref={recaptchaRef} style={{display: 'inline-block', marginBottom: '16px'}}></div>
                    <br/>
                    <button type="submit" className="button is-primary is-medium mt-3">Send Message</button>
                  </div>
                </form>
              </div>
            </div>
            <div className="success-message">
              {sending ? (
                <div className="sending-spinner"></div>
              ) : (
                <div className="success-checkmark">&#10004;</div>
              )}
              <h3 className="title is-4 has-text-white mt-4">{sending ? "Sending..." : "Thanks for contacting us!"}</h3>
              <p className="has-text-grey-light">{sending ? "Please wait a moment" : "We'll get back to you shortly."}</p>
            </div>
          </div>

          <div className="columns is-centered mt-6">
            <div className="column is-4 has-text-centered">
              <i className="fa-solid fa-envelope fa-2x has-text-primary mb-3"></i>
              <h4 className="title is-5 has-text-white">Email</h4>
              <p><a href="mailto:hello@sitechesports.com" className="has-text-grey-light">hello@sitechesports.com</a></p>
            </div>
            <div className="column is-4 has-text-centered">
              <i className="fa-brands fa-linkedin fa-2x has-text-primary mb-3"></i>
              <h4 className="title is-5 has-text-white">LinkedIn</h4>
              <p><a href="https://linkedin.com/company/sitech-esports/" target="_blank" rel="noopener noreferrer" className="has-text-grey-light">Sitech eSports</a></p>
            </div>
            <div className="column is-4 has-text-centered">
              <i className="fa-brands fa-instagram fa-2x has-text-primary mb-3"></i>
              <h4 className="title is-5 has-text-white">Instagram</h4>
              <p><a href="https://www.instagram.com/sitechesports/" target="_blank" rel="noopener noreferrer" className="has-text-grey-light">@sitechesports</a></p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
